import React, { useState, useEffect, useContext } from 'react';
import { User } from 'type/type';
import { decryptAES256, getUserList } from 'api/api';
import hubLayout from 'styles/css/hubLayout.module.css';
import { useNavigate } from 'react-router-dom';
import { useModal } from 'components/common/ModalLayout';
import Loading from 'components/common/Loading';
import { AgentLoginInfoContext } from 'pages/Layout';

const UserInfoComponent = ({ users, setUserId }: { users: User[], setUserId: Function }) => {
  const REACT_APP_SECRET_KEY = process.env.REACT_APP_SECRET_KEY!;
  const REACT_APP_SECRET_IV = process.env.REACT_APP_SECRET_IV!;
  const [user, setUser] = useState<User>(users[0]);
  const [decryptMobile, setDecryptMobile] = useState<string>('');

  function handleChange(event: React.ChangeEvent<HTMLSelectElement>) {
    setDecryptMobile(decryptAES256(users[parseInt(event.target.value, 10)].mobile, REACT_APP_SECRET_KEY!, REACT_APP_SECRET_IV!));
    setUser(users[parseInt(event.target.value, 10)]);
  }
  useEffect(() => {
    setUserId(user.id);
  }, [user]);
  useEffect(() => {
    setUser(users[0]);
    setDecryptMobile(decryptAES256(users[0].mobile, REACT_APP_SECRET_KEY!, REACT_APP_SECRET_IV!));
  }, [users]);
  return (
    <>
      <li className={`${hubLayout.display_flex} ${hubLayout.center} ${hubLayout.label_text}`}>
        <div className={`${hubLayout.width_100}`}>고객 ID</div>
        <div className={`${hubLayout.inp_select}`}>
          <select className={`${hubLayout.inp_select}`} onChange={(e) => handleChange(e)}>
            {users && users.map((user, idx) => (
              <option key={idx} value={idx}>{user.id}</option>
            ))}
          </select>
        </div>
      </li>
      <InputComponent name="userName" title="고객명" userData={user.name} />
      <InputComponent name="userMobile" title="연락처" userData={decryptMobile} />
      <InputComponent name="userAddress" title="주소" userData={`${user.address} ${user.address_detail}`} />
    </>
  );
}



const InputComponent = ({ name, title, userData }: { name: string, title: string, userData: string }) => {
  return (
    <>
      <li className={`${hubLayout.display_flex} ${hubLayout.center} ${hubLayout.label_text}`}>
        <div className={`${hubLayout.width_100}`}>{title}</div>
        <input type="text" name={name} value={userData} readOnly />
      </li>
    </>
  );
}

interface SearchInputType {
  type: string,
  value: string,
  jisa_code: string[],
};

function SearchUser() {
  const { agentLoginInfo } = useContext(AgentLoginInfoContext);
  const navigate = useNavigate();
  const { showModal } = useModal();
  const [loading, setLoading] = useState(false);

  const [users, setUsers] = useState<User[] | undefined>(undefined);
  const [userId, setUserId] = useState<string>('');
  const [searchObj, setSearchObj] = useState<SearchInputType>({
    type: "id",
    value: "",
    jisa_code: Array.isArray(agentLoginInfo.jisa_code)
      ? (agentLoginInfo.jisa_code as string[])
      : typeof agentLoginInfo.jisa_code === "string"
      ? [agentLoginInfo.jisa_code] // 문자열이면 배열로 변환
      : [],
  });

  const getUser = async () => {
    setLoading(true);
    try {
      if (!searchObj.value) {showModal("alert","검색어를 입력해주세요."); return;}
      const usersResponse = await getUserList(0, 0, { [searchObj.type] : searchObj.value, jisa_code: searchObj.jisa_code});
      if (usersResponse.code === 200) {
        setUsers(usersResponse.data);
      } else {
        showModal("alert", usersResponse.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // 검색 type 변경
  const handleSearchType = (type: string) => {
    setSearchObj(prev => ({...prev, type, value: "" }));
  };
  // 검색 value 변경
  const handleSearchValue = (value: string) => {
    if (searchObj.type === "id") value = value.toLowerCase();
    setSearchObj(prev => ({...prev, value}));
  };

  const navigatorProductMgmt = () => {
    if (userId) {
      navigate(`/agent/recorder/list/${userId}`);
    } else {
      showModal("alert", "고객 조회 후 이용가능합니다.");
    }
  };

  const handleKeyDown = async (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') getUser();
  }
  useEffect(() => {
    setUserId(userId);
  }, [userId]);
  return (
    <>
      {loading ? <Loading />
      :
        <div className={`${hubLayout.cnt_box}`}>
          <div className={`${hubLayout.acc__cnt}`}>
            <div className={`${hubLayout.sec_title}`}>
              <h2>고객 조회</h2>
              <span onClick={() => navigate(-1)}>X</span>
            </div>
            <h2 className={`${hubLayout.cnt_title} ${hubLayout.tx_blue}`}>검색</h2>
            <ul className={`${hubLayout.inp_list}`}>
              <li className={`${hubLayout.display_flex}`}>
                <div className={`${hubLayout.inp_select}`} >
                  <select name="search_type" className={`${hubLayout.inp_select}`} onChange={(e) => handleSearchType(e.target.value)} value={searchObj.type}>
                    <option value={`id`}>ID</option>
                    <option value={`contract_no`}>계약번호</option>
                    <option value={`mac`}>MAC</option>
                  </select>
                </div>
                <input type="text" name="search_value" onChange={(e) => handleSearchValue(e.target.value)} value={searchObj.value} onKeyUp={handleKeyDown} />
              </li>
            </ul>
            <div className={`${hubLayout.btn_group}`}>
              <button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.blue}`} onClick={getUser}>검색</button>
            </div>
            {users && users.length > 0 ?
            <>
              <ul className={`${hubLayout.inp_list}`}>
                <UserInfoComponent users={users} setUserId={setUserId} />
              </ul>
              <div className={`${hubLayout.btn_group}`}>
                <button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.blue}`} onClick={navigatorProductMgmt}>장비 관리</button>
              </div>
            </>
            :
              <p className={`${hubLayout.empty_data}`} >조회된 계정이 없습니다.</p>
            }
          </div>
        </div>
      }
    </>
  );
}

export default SearchUser;